import { PPQN } from "@opendaw/lib-dsp";
export const UpdateClockRate = PPQN.fromSignature(1, 384);
